import { Helmet } from "react-helmet-async";

const PUBLIC_URL = (import.meta.env.VITE_PUBLIC_URL as string | undefined)?.replace(/\/$/, "") ?? "";
const SITE_NAME = "MOTUS Bug Board";

export type PageHeadProps = {
  title: string;
  description: string;
  path?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, unknown>;
};

export default function PageHead({ title, description, path, noIndex, jsonLd }: PageHeadProps) {
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const canonical = PUBLIC_URL && path ? `${PUBLIC_URL}${path}` : undefined;
  const ogImage = PUBLIC_URL ? `${PUBLIC_URL}/opengraph.jpg` : "/opengraph.jpg";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={ogImage} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
